const RANKING_EXPORT_COLUMN_MAP_KEYS = {
  RankingClose: "rankingCloseExportColumnMap",
  RankingCloseMonthly: "rankingCloseMonthlyExportColumnMap",
  RankingOpenExcludeQDII: "rankingOpenExcludeQDIIExportColumnMap",
  RankingOpenExcludeQDIIMonthly: "rankingOpenExcludeQDIIMonthlyExportColumnMap",
  RankingQDIIOffShore: "rankingQDIIOffShoreExportColumnMap",
  RankingQDIIOffShoreMonthly: "rankingQDIIOffShoreMonthlyExportColumnMap",
  RankingSearch: "rankingSearchExportColumnMap",
  RankingSearchMonthly: "rankingSearchMonthlyExportColumnMap",
};

function safeParse(rawValue) {
  if (rawValue == null || rawValue === "") {
    return null;
  }

  if (typeof rawValue === "string") {
    try {
      return JSON.parse(rawValue);
    } catch (e) {
      return null;
    }
  }

  return rawValue;
}

function normalizeColumns(storedValue) {
  if (Array.isArray(storedValue)) {
    return { columns: storedValue, metadata: {} };
  }

  if (storedValue && Array.isArray(storedValue.columns)) {
    const { columns, ...metadata } = storedValue;
    return { columns, metadata };
  }

  return { columns: [], metadata: {} };
}

function getMapByKey(mapKey, getNameAndValueFn) {
  const raw = getNameAndValueFn(mapKey);
  const parsed = safeParse(raw);
  const normalized = normalizeColumns(parsed);

  return {
    key: mapKey,
    columns: normalized.columns,
    metadata: normalized.metadata,
  };
}

export function getRankingExportColumnsByPage(pageName, getNameAndValueFn) {
  const mapKey = RANKING_EXPORT_COLUMN_MAP_KEYS[pageName];
  if (!mapKey || typeof getNameAndValueFn !== "function") {
    return [];
  }

  return getMapByKey(mapKey, getNameAndValueFn).columns;
}

export function getRankingExportMapSnapshot(getNameAndValueFn) {
  if (typeof getNameAndValueFn !== "function") {
    return {};
  }

  const snapshot = {};
  Object.keys(RANKING_EXPORT_COLUMN_MAP_KEYS).forEach((pageName) => {
    const mapKey = RANKING_EXPORT_COLUMN_MAP_KEYS[pageName];
    snapshot[pageName] = getMapByKey(mapKey, getNameAndValueFn);
  });

  return snapshot;
}

export { RANKING_EXPORT_COLUMN_MAP_KEYS };
